module.exports = __webpack_public_path__ + "img/sumary_current_electric.04e06cfb.svg";